// extracted by mini-css-extract-plugin
module.exports = {"container":"feeds_container__-1fXg","feeds-wrapper":"feeds_feeds-wrapper__2aILE","space-y":"feeds_space-y__25W81"};